import type { SeoResolver } from '../types';

/**
 * SEO for a selected PDS (ration / fair price) shop. Moved verbatim from the
 * inline branches in SEO.tsx so the rendered title/description/schema are
 * byte-identical to the pre-framework output.
 */
export const pdsSeoResolver: SeoResolver = (ctx) => {
  const shop = ctx.selections.pdsShop;
  if (!shop) return null;

  const p = shop.properties;
  const { siteName, pageUrl } = ctx;

  const codePart = p.shop_code ? ` (Shop No. ${p.shop_code})` : '';
  const title = `${p.name || 'Ration Shop'}${codePart} — Address & Phone | Ration Shop in ${p.district || 'Tamil Nadu'} | ${siteName}`;

  const head = `Ration shop ${p.name || ''}${p.shop_code ? ` (Shop Code ${p.shop_code})` : ''} in ${p.village || p.district || 'Tamil Nadu'}`.replace(/\s+/g, ' ').trim();
  const extra: string[] = [];
  if (p.incharge) extra.push(`In-charge: ${p.incharge}`);
  if (p.contact_no) extra.push(`Phone: ${p.contact_no}`);
  if (p.address) extra.push(`Address: ${p.address}`);
  const tail = extra.length ? ` ${extra.join('. ')}.` : '';
  const description = `${head}.${tail} View exact location, map, and directions on ${siteName}.`;

  const coords = shop.geometry?.coordinates as number[] | undefined;
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'GovernmentOffice',
    name: `${p.name || 'Ration Shop'}${p.shop_code ? ` (Ration Shop ${p.shop_code})` : ''}`,
    url: pageUrl,
    parentOrganization: {
      '@type': 'GovernmentOrganization',
      name: 'Tamil Nadu Public Distribution System (TNPDS)'
    },
    address: {
      '@type': 'PostalAddress',
      ...(p.address ? { streetAddress: p.address } : {}),
      ...(p.village || p.taluk ? { addressLocality: p.village || p.taluk } : {}),
      addressRegion: p.district || 'Tamil Nadu',
      addressCountry: 'IN'
    }
  };
  if (p.shop_code) schema.branchCode = p.shop_code;
  if (p.contact_no) schema.telephone = `+91${p.contact_no}`;
  if (p.incharge) schema.employee = { '@type': 'Person', name: p.incharge, jobTitle: 'Shop In-charge' };
  if (coords && coords.length >= 2) {
    schema.geo = { '@type': 'GeoCoordinates', latitude: coords[1], longitude: coords[0] };
  }

  return {
    title,
    description,
    breadcrumbLabel: p.name,
    schema
  };
};
